import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import { BoardMembershipRoles } from '../constants/Enums';
import List from '../components/List';

const makeMapStateToProps = () => {
  const selectListById = selectors.makeSelectListById();
  const selectCardIdsByListId = selectors.makeSelectCardIdsByListId();
  const selectListReportDataByListId = selectors.makeSelectListReportDataByListId();
  const selectListPointsSum = selectors.makeSelectListPointsSum();
  return (state, { id, index }) => {
    const { name, isPersisted, boardId } = selectListById(state, id);
    const { projectId } = selectors.selectPath(state);
    const cardIds = selectCardIdsByListId(state, id);
    const allProjectsToLists = selectors.selectProjectsToListsForCurrentUser(state);
    const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
    const currentUser = selectors.selectCurrentUser(state);
    const isSAdmin = currentUser?.isSAdmin;
    const config = selectors.selectConfig(state);
    const superuserIds = Array.isArray(config?.superuserIds) ? config.superuserIds : [];
    const isSuperuser = currentUser?.id && superuserIds.map(String).includes(String(currentUser.id));
    const isCurrentUserEditor =
      !!currentUserMembership && currentUserMembership.role === BoardMembershipRoles.EDITOR;

    const pointSystem = selectors.selectPointSystemForCurrentBoard(state);
    const isPointSystemEnabled = pointSystem?.isEnabled === true;
    const pointSystemId = pointSystem?.id;
    
    // Проверяем условия для отчета за месяц - доступно для всех пользователей
    const isMonthlyReportAvailable = isPointSystemEnabled;

    const listReportData = selectListReportDataByListId(state, id);
    const isMonthClosed = listReportData?.closed === true;

    // Получаем сумму баллов для списка
    const pointsSum = pointSystemId ? selectListPointsSum(state, id, pointSystemId) : 0;

    return {
      id,
      index,
      name,
      isPersisted,
      cardIds,
      boardId,
      projectId,
      allProjectsToLists,
      canEdit: isCurrentUserEditor === false ? isSAdmin : isCurrentUserEditor,
      isSuperuser,
      isMonthlyReportAvailable,
      isMonthClosed,
      pointsSum,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => entryActions.updateList(id, data),
      onMove: (index) => entryActions.moveList(id, index),
      onTransfer: (boardId) => entryActions.transferList(id, boardId),
      onDelete: () => entryActions.deleteList(id),
      onArchive: () => entryActions.archiveList(id),
      onBoardFetch: entryActions.fetchBoard,
      onMonthlyReportOpen: () => entryActions.openMonthlyReportModal(id),
      onCardCreate: (data, autoOpen) => entryActions.createCard(id, data, autoOpen),
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(List);
